import React from 'react';
import styles from './WhyTeezash.module.css';

const WhyTeezash = () => {
  return (
    <section className={styles.section} id="why">
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>WHY TEEZASH?</h1>
          <p className={styles.description}>
            At Teezash, we are driven by a passion for innovation and a commitment to safety. 
            Our solutions are built on cutting-edge IoT technology, tailored to meet real-world needs. 
            With a focus on quality, reliability and user-centric design, we strive to empower homes 
            and businesses with smart, efficient and accessible safety solutions. Choose Teezash for 
            technology that makes life safer, smarter and better.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyTeezash;